import { render, staticRenderFns } from "./ExpandTray.vue?vue&type=template&id=00bdd23e&scoped=true&"
import script from "./ExpandTray.vue?vue&type=script&lang=js&"
export * from "./ExpandTray.vue?vue&type=script&lang=js&"
import style0 from "./ExpandTray.vue?vue&type=style&index=0&id=00bdd23e&lang=scss&scoped=true&"
import style1 from "./ExpandTray.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bdd23e",
  null
  
)

export default component.exports